import { AxiosRequest } from "../ApiCall";
import { configEnv } from "../constant";

/** One entry of the language registry served by `GET /languages`. */
export interface LanguageDef {
    code: string;
    name: string;
    nativeName: string;
    script: string;
    direction: "ltr" | "rtl";
    pdfFontFamily: string;
    ttsVoice: string;
    enabled: boolean;
}

export const languageApi = {
    /**
     * `GET /languages`. Public: it needs no session, so the test taker and the
     * shared report pages can read it too. `silentError` keeps the global
     * interceptor from toasting a failure; the registry has a static fallback,
     * so a visitor should never be told about it.
     */
    list: async (): Promise<LanguageDef[]> => {
        const res = await AxiosRequest(
            "GET",
            `${configEnv.baseUrl}/languages`,
            undefined,
            {},
            { silentError: true }
        );
        const languages = res?.data?.data?.languages;
        // A reply without a list is a failed load, so the registry stays on
        // its static fallback rather than becoming an empty one.
        if (!Array.isArray(languages)) {
            throw new Error("The languages response carried no languages list");
        }
        return languages;
    },
};
